import styled from 'styled-components'

export const OptionButtonContainer = styled.div<{ checked: boolean, isIncorrect?: boolean }>`
  background: ${props => props.checked ? '#3D6666' : '#FFF'};
  border: 2px solid ${props => props.isIncorrect ? '#E84242' : props.checked ? '#3D6666' : '#7B7C82'};
  color: ${props => props.isIncorrect ? '#E84242' : props.checked ? '#FFF' : '#7B7C82'};
  padding: 12px 28px;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  & input {
    display: none;
  }
`